import { ChangeDetectorRef, Component, OnInit } from '@angular/core';
import { MatDialogRef } from '@angular/material/dialog';
import { Router } from '@angular/router';
import { data } from 'jquery';
import { Csp5050Service } from '../../CSPService/CSP5050/csp5050.service';
import { Csp5050Class } from '../../CSPClass/CSP5050/csp5050-class';
@Component({
  selector: 'kt-csp5050-view',
  templateUrl: './csp5050-view.component.html',
  styleUrls: ['./csp5050-view.component.scss']
})
export class Csp5050ViewComponent implements OnInit {

   lblPageTitle: string = "";
  PaidFeeList: any[] = [];
  OtherFeeList: any[] = [];
  PaidFeeInfo = false;
  constructor(private router: Router,public dialogRef: MatDialogRef<Csp5050ViewComponent>, private objCsp5050Service:Csp5050Service,private changeDetectorRef: ChangeDetectorRef
  ) { }

  ngOnInit() {
       this.onGetDatas();
  }
 onGetDatas() {
   if (localStorage.getItem('currentUser') != null) {
              var userLoginDetails = JSON.parse(localStorage.getItem('currentUser'));
            var classobj = new Csp5050Class();
            classobj.UserNam= userLoginDetails.UserNam;
              this.objCsp5050Service.PaidFee(classobj).subscribe((data) => {    
               this.PaidFeeList = data.Item1  || []; 
               this.OtherFeeList = data.Item2 || [];
            });
            this.changeDetectorRef.detectChanges();
          }
        }
indianFormatter = new Intl.NumberFormat('en-IN', {
  minimumFractionDigits: 2,
  maximumFractionDigits: 2
});

formatIN(value: number): string {
  const num = Number(value) || 0;
  return this.indianFormatter.format(num);
}


//Total Calculations for Registered Other Fee Tab

RegisteredTotalAmountToPay(): number {
  return this.PaidFeeList.reduce((sum, item) => {
    const value = Number(String(item.FeeAmount).replace(/,/g, '')) || 0;
    return sum + value;
  }, 0);
}

RegisteredTotalAmountPaid(): number {
  return this.PaidFeeList.reduce((sum, item) => {
    const value = Number(String(item.PaidAmount).replace(/,/g, '')) || 0;
    return sum + value;
  }, 0);
}

RegisteredTotalAmountDue(): number {
  return this.PaidFeeList.reduce((sum, item) => {
    const value = Number(String(item.amount_to_pay).replace(/,/g, '')) || 0;
    return sum + value;
  }, 0);
}
//End of Total Calculations for Registered  Fee Tab


//Total Calculations for Other Fee Tab

OtherFeeTotalAmountToPay(): number {
  return this.OtherFeeList.reduce((sum, item) => {
    const value = Number(String(item.FeeAmount).replace(/,/g, '')) || 0;
    return sum + value;
  }, 0);
}

OtherFeeTotalAmountPaid(): number {
  return this.OtherFeeList.reduce((sum, item) => {
    const value = Number(String(item.PaidAmount).replace(/,/g, '')) || 0;
    return sum + value;
  }, 0);
}

OtherFeeTotalAmountDue(): number {
  return this.OtherFeeList.reduce((sum, item) => {
    const value = Number(String(item.amount_to_pay).replace(/,/g, '')) || 0;
    return sum + value;
  }, 0);
}
//End of Total Calculations for Other Fee Tab

  onClose() {
  if (this.dialogRef) {
    this.dialogRef.close();
  }
}
   getComponentTitle() {
    let result =  "Paid Fee Details";
    return result;
   }
}
